export default __webpack_public_path__ + "static/img/vogue_scene_animated_0613.79a0cb9.webp";